import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataService {
    styleItems: any;
    loading: boolean = false;
}
